import map from 'lodash/map'
import find from 'lodash/find'
import randomKey from 'utils/randomKey'
import randomImage from 'utils/randomImage'
import proposalColors from 'constants/proposalColors'

export const createCustomField = (type, data) => {
  return {
    ...data,
    key: randomKey(),
    type,
  }
}

export const updateCustomField = (fields, key, nextData) => {
  return fields.map((fieldData) => {
    if (fieldData.key === key) {
      return { ...fieldData, ...nextData }
    }
    return fieldData
  })
}

export const createProposalDataFromTemplate = (template, newIndex, disabled = true) => {
  return {
    ...template,
    image: randomImage(),
    data: {
      ...template.data,
      color: proposalColors[newIndex % proposalColors.length],
      disabled,
      customerFields: map(
        template.data.customerFields,
        field => createCustomField(field.type, field)
      ),
      fields: map(
        template.data.fields,
        field => createCustomField(field.type, field)
      )
    }
  }
}

export const getProposalField = (proposal, type) => {
  return proposal && proposal.data && find(proposal.data.fields, { type })
}
